import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IModule} from "../../models/IModule";
import {EnumModuleTypes} from "../../enums/EnumModuleTypes";


interface modulesState {
    modules: {
        basic: IModule[],
        additional: IModule[]
    }
}


const initialState: modulesState = {
    modules: {
        basic: [],
        additional: []
    }

}

export const modulesSlice = createSlice({
    name: 'modules',
    initialState,
    reducers: {
        setModules(state, action: PayloadAction<IModule[]>) {
            state.modules.basic = action.payload.filter(module => module.type === EnumModuleTypes.basic)
            state.modules.additional = action.payload.filter(module => module.type === EnumModuleTypes.additional)
        },
        setBasicModules(state, action: PayloadAction<IModule[]>) {
            state.modules.basic = action.payload
        },
        setAdditionalModules(state, action: PayloadAction<IModule[]>) {
            state.modules.additional = action.payload
        },
        updateModule(state, action: PayloadAction<IModule>) {
            state.modules[action.payload.type] = state.modules[action.payload.type].map(module => {
                if (module.id === action.payload.id) {
                    return {
                        ...action.payload
                    }
                }
                return {
                    ...module
                }
            })
        },
        addModule(state, action: PayloadAction<IModule>) {
            state.modules[action.payload.type].push(action.payload)
        },
        deleteModule(state, action: PayloadAction<number>) {
            state.modules.additional =  state.modules.additional.filter(module => module.id !== action.payload)
            state.modules.basic =  state.modules.basic.filter(module => module.id !== action.payload)
        }

    }
})

export default modulesSlice.reducer;